import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AppProvider } from "./context/AppContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import EnquiryModal from "./components/EnquiryModal";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import ErrorBoundary from "./components/ErrorBoundary";
import Home from "./pages/Home";
import ProjectsListing from "./pages/ProjectsListing";
import ProjectDetail from "./pages/ProjectDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import GoldenVisa from "./pages/GoldenVisa";
import Areas from "./pages/Areas";
import AreaDetail from "./pages/AreaDetail";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const SiteLayout = ({ children }) => (
  <>
    <Header />
    <ErrorBoundary>{children}</ErrorBoundary>
    <Footer />
    <EnquiryModal />
    <FloatingWhatsApp />
  </>
);

function App() {
  return (
    <div className="App min-h-screen bg-gobra-cream">
      <AppProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/" element={<SiteLayout><Home /></SiteLayout>} />
            <Route path="/projects" element={<SiteLayout><ProjectsListing /></SiteLayout>} />
            <Route path="/project/:id" element={<SiteLayout><ProjectDetail /></SiteLayout>} />
            <Route path="/about" element={<SiteLayout><About /></SiteLayout>} />
            <Route path="/contact" element={<SiteLayout><Contact /></SiteLayout>} />
            <Route path="/golden-visa" element={<SiteLayout><GoldenVisa /></SiteLayout>} />
            <Route path="/areas" element={<SiteLayout><Areas /></SiteLayout>} />
            <Route path="/areas/:name" element={<SiteLayout><AreaDetail /></SiteLayout>} />
            <Route path="/login" element={<SiteLayout><Login /></SiteLayout>} />
            <Route path="/privacy" element={<SiteLayout><PrivacyPolicy /></SiteLayout>} />
          </Routes>
        </BrowserRouter>
      </AppProvider>
    </div>
  );
}

export default App;
